import { featuredArticles, catStyle, type Article } from "@/mocks/feed";

interface Props {
  onRead: (a: Article) => void;
}

export default function Feature({ onRead }: Props) {
  const [head, ...rest] = featuredArticles;

  const renderCard = (item: Article, i: number) => (
    <article
      key={item.id}
      onClick={() => onRead(item)}
      className={`group flex cursor-pointer overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-200 ${i === 0 ? "flex-col md:flex-row" : "flex-col"}`}
    >
      <div className={`relative overflow-hidden ${i === 0 ? "md:w-1/2 md:aspect-auto aspect-[16/9]" : "aspect-[16/9] w-full"}`}>
        <img
          src={item.image}
          alt={item.title}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className={`flex flex-col justify-center p-5 md:p-7 ${i === 0 ? "md:w-1/2" : ""}`}>
        <div className="flex items-center gap-2">
          <span className={`rounded-md px-2 py-1 text-xs font-medium ${catStyle[item.category]}`}>{item.category}</span>
          <span className="text-xs text-foreground-500">{item.time}</span>
        </div>
        <h3 className={`mt-3 font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 ${i === 0 ? "text-xl md:text-2xl line-clamp-3" : "line-clamp-2 text-base"}`}>
          {item.title}
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">{item.summary}</p>
        <div className="mt-4 flex items-center gap-2 text-sm text-primary-700">
          <span className="font-medium">展开阅读</span>
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
        </div>
      </div>
    </article>
  );

  return (
    <section id="feature" className="w-full scroll-mt-20 bg-accent-100/50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-accent-800 border border-accent-200">
              <i className="ri-newspaper-line" aria-hidden="true"></i> 深度盘点
            </p>
            <h2 className="font-display mt-3 text-2xl md:text-4xl text-foreground-950">大事全景 · 不只吃瓜</h2>
            <p className="mt-2 text-sm text-foreground-600">把事件背景、关键节点与多方声音串成一条线，让你吃得明白、看得通透。</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <div className="lg:row-span-2">{renderCard(head, 0)}</div>
          {rest.map((item, i) => (
            <div key={item.id}>{renderCard(item, i + 1)}</div>
          ))}
        </div>
      </div>
    </section>
  );
}